import React from 'react';
import { ExternalLink } from 'lucide-react';
import { adSurfaceEnabled } from '../../config/ads';
import { adSlotVisible } from '../../utils/adsEnabled';
import { isValidAdDestination } from '../../utils/adDestinationUrl';
import {
  InlineRoot,
  Thumb,
  Body,
  TopRow,
  AdTag,
  Sponsor,
  Title,
  Desc,
  CtaDesktop,
} from './AdInline.styled';

export default function AdInline({ ad, pageKey, onLinkClick }) {
  if (!adSurfaceEnabled() || (pageKey && !adSlotVisible(pageKey)) || !ad?.image) return null;

  const dest = isValidAdDestination(ad.url);
  const href = dest ? ad.url : '#';
  const onClick = (e) => {
    if (!dest) e.preventDefault();
    else onLinkClick?.(e);
  };

  return (
    <InlineRoot
      href={href}
      onClick={onClick}
      target={dest ? '_blank' : undefined}
      rel={dest ? 'noopener noreferrer sponsored' : undefined}
    >
      <Thumb>
        <img src={ad.image} alt="" loading="lazy" />
      </Thumb>
      <Body>
        <TopRow>
          <AdTag>Ad</AdTag>
          <Sponsor>{ad.sponsor}</Sponsor>
        </TopRow>
        <Title>{ad.title}</Title>
        <Desc>{ad.description}</Desc>
      </Body>
      <CtaDesktop>
        {ad.cta} <ExternalLink size={10} />
      </CtaDesktop>
    </InlineRoot>
  );
}
